import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlignmentCenter: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="alignment-center"><path d="M3.75 4.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 12H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 19.25H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAlignmentCenter;
